import { Link, useNavigate } from "react-router-dom";

export const Footer = () => {
  const currentYear = new Date().getFullYear();
  const navigate = useNavigate();
  
  const handleNavigation = (path) => (e) => {
    e.preventDefault();
    navigate(path);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };
  
  return (
    <footer className="py-8 px-4 bg-black">
      <div className="max-w-7xl mx-auto text-center">
        <p 
          className="text-sm text-gray-400"
          data-testid="footer-copyright"
        >
          Copyright © {currentYear} Darkar Company Studios, LLC. <Link 
            to="/admin"
            className="hover:opacity-70 transition-opacity"
            title="Admin"
            data-testid="footer-admin-link"
          >🔥</Link>
        </p>
        <p className="text-xs text-gray-500 mt-2 flex flex-wrap justify-center items-center gap-x-1 gap-y-1">
          <a href="/terminos" onClick={handleNavigation("/terminos")} className="hover:text-gray-300 transition-colors cursor-pointer whitespace-nowrap">Términos de Servicio</a>
          <span>|</span>
          <a href="/privacidad" onClick={handleNavigation("/privacidad")} className="hover:text-gray-300 transition-colors cursor-pointer whitespace-nowrap">Política de Privacidad</a>
          <span>|</span>
          <a href="/contacto" onClick={handleNavigation("/contacto")} className="hover:text-gray-300 transition-colors cursor-pointer whitespace-nowrap">Contacto</a>
        </p>
      </div>
    </footer>
  );
};
